import React from 'react';
import { Col, Row, Input, Label } from 'reactstrap';

const DeliveryVesselFirstLocation = ({
  form,
  deliveryincotermformData,
  handleDeliveryNumberChangeIncoterm,
}) => {
  return (
    <Row>
      <Col sm={8}>
        <Row>
          <Col sm={12}>
            <div className='mb-2'>
              <Label className='form-label fw-semibold'>
                {deliveryincotermformData.incotermLocationName}
              </Label>
            </div>
          </Col>

          {/* Draft */}
          <Col sm={4}>
            <div className='mb-2'>
              <Label className='form-label'>Draft(m)</Label>
              <div className='input-group mb-2'>
                <span className='input-group-text'>Min</span>
                <Input
                  type='number'
                  name='loc1Draft1'
                  id='loc1Draft1'
                  value={deliveryincotermformData.loc1Draft1 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc1Draft1')}
                />
                <span className='input-group-text'>m</span>
              </div>
              <div className='input-group'>
                <span className='input-group-text'>Max</span>
                <Input
                  type='number'
                  name='loc1Draft2'
                  id='loc1Draft2'
                  value={deliveryincotermformData.loc1Draft2 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc1Draft2')}
                />
                <span className='input-group-text'>m</span>
              </div>
            </div>
          </Col>

          {/* LOA */}
          <Col sm={4}>
            <div className='mb-2'>
              <Label className='form-label'>LOA(m)</Label>
              <div className='input-group mb-2'>
                <span className='input-group-text'>Min</span>
                <Input
                  type='number'
                  name='loc1Loa1'
                  id='loc1Loa1'
                  value={deliveryincotermformData.loc1Loa1 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc1Loa1')}
                />
                <span className='input-group-text'>m</span>
              </div>
              <div className='input-group'>
                <span className='input-group-text'>Max</span>
                <Input
                  type='number'
                  id='loc1Loa2'
                  name='loc1Loa2'
                  value={deliveryincotermformData.loc1Loa2 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc1Loa2')}
                />
                <span className='input-group-text'>m</span>
              </div>
            </div>
          </Col>

          {/* DWT */}
          <Col sm={4}>
            <div className='mb-2'>
              <Label className='form-label'>DWT(MT)</Label>
              <div className='input-group mb-2'>
                <span className='input-group-text'>Min</span>
                <Input
                  type='number'
                  id='loc1Dwt1'
                  name='loc1Dwt1'
                  value={deliveryincotermformData.loc1Dwt1 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc1Dwt1')}
                />
                <span className='input-group-text'>m</span>
              </div>
              <div className='input-group'>
                <span className='input-group-text'>Max</span>
                <Input
                  type='number'
                  id='loc1Dwt2'
                  name='loc1Dwt2'
                  value={deliveryincotermformData.loc1Dwt2 || ''}
                  onChange={handleDeliveryNumberChangeIncoterm('loc1Dwt2')}
                />
                <span className='input-group-text'>m</span>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DeliveryVesselFirstLocation;
